export default __webpack_public_path__ + "static/media/background.48110214.mp4";